export interface ProductExtraItem {
  id: string;
  key: string;
  description: string;
  price: number;
  notes: string;
}
